
import { IComboBoxOption, Panel, PanelType } from '@fluentui/react';
import React, { useState, useCallback } from 'react';
import { PanelHeader } from './PanelHeader';
import { PanelFooter } from './PanelFooter';
export interface IPanelFilter{
    isOpen: boolean;
    onDismiss?: () => void;
    children?: any;
    textHeader:string
    subTextHeader?:string,
    resetFilter: () => void;
    buscar: () => void;
}
export const PanelFilter=(props:IPanelFilter)=>{
  return(
    <Panel
            type={PanelType.smallFixedFar}
            onRenderHeader={() =>
                <PanelHeader
                subTextHeader={props.subTextHeader??""}
                textHeader={props.textHeader}
                />
            }
            onRenderFooter={() =>
                <PanelFooter
                    texto="Buscar"
                    texto2={"Limpiar"}
                    onClick={props.buscar}
                    disableButton={false}
                    onDismiss={props.resetFilter}
                />
            }
            isFooterAtBottom
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
        >
        {props.children}

        </Panel>
  )
}